import React from 'react';
import { PrintRichText } from './PrintRichText';
import { isUnfitSurveyStudentLabel } from './printSurveyUtils';

interface PrintSurveyExampleCalloutProps {
  content: string;
  title?: string;
}

export function PrintSurveyExampleCallout({ content, title }: PrintSurveyExampleCalloutProps) {
  const trimmed = String(content || '').trim();
  if (!trimmed) return null;

  const safeTitle =
    title && !isUnfitSurveyStudentLabel(title) ? String(title).trim() : 'Ejemplo de referencia';

  return (
    <aside className="print-survey-example" aria-label="Ejemplo de encuesta">
      <p className="print-survey-example__kicker">Ejemplo</p>
      {safeTitle && safeTitle !== 'Ejemplo de referencia' ? (
        <p className="print-survey-example__title">{safeTitle}</p>
      ) : null}
      <div className="print-survey-example__body">
        <PrintRichText text={trimmed} />
      </div>
    </aside>
  );
}
